export default __webpack_public_path__ + "static/media/moscow-method.a85bafb3.svg";